import BaseModel from './BaseModel';

class EAPPFilterOption extends BaseModel {}

EAPPFilterOption.collection = 'EAPPFilterOptions';

export default EAPPFilterOption;
